import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const breadcrumbsListFn = /* @__PURE__ */ createRecipe('breadcrumbs-list', {
  "size": "default"
}, [])

const breadcrumbsListVariantMap = {
  "size": [
    "default",
    "narrow"
  ]
}

const breadcrumbsListVariantKeys = Object.keys(breadcrumbsListVariantMap)

export const breadcrumbsList = /* @__PURE__ */ Object.assign(memo(breadcrumbsListFn.recipeFn), {
  __recipe__: true,
  __name__: 'breadcrumbsList',
  __getCompoundVariantCss__: breadcrumbsListFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: breadcrumbsListVariantKeys,
  variantMap: breadcrumbsListVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, breadcrumbsListVariantKeys)
  },
  getVariantProps: breadcrumbsListFn.getVariantProps,
})